<template>
  <div class="flex pt-3 rounded-b space-x-2">
    <slot />
  </div>
</template>
